import React, { useRef } from 'react'
import { legacyImageURL } from 'components/LegacyImage'
import { SpotDiffOverlay } from 'steps/spot-the-diff/components/SpotDiffOverlay'
import { InteractionLayer } from 'steps/spot-the-diff/components/InteractiveLayer'
import { CIRCLE_SIZE, ANIMATION_DURATION } from 'steps/spot-the-diff/constants'

const ImageContainer = ({
  image,
  state,
  findDifference,
  start,
  differenceSelected,
}) => {
  const [spots, setSpots] = React.useState([])
  const imgRef = useRef(null)

  const createNewSpot = (x, y, isCorrect) => {
    const newSpot = {
      id: Date.now().toString(),
      x,
      y,
      radius: CIRCLE_SIZE,
      isCorrect,
    }
    setSpots(prevSpots => [...prevSpots, newSpot])
    setTimeout(() => {
      setSpots(prevSpots => prevSpots.filter(spot => spot.id !== newSpot.id))
    }, ANIMATION_DURATION)
  }

  const handleUserClick = e => {
    const tolerance = 6
    const rect = e.target.getBoundingClientRect()

    const x = e.clientX - CIRCLE_SIZE / 2 - rect.left
    const y = e.clientY - CIRCLE_SIZE / 2 - rect.top

    const imageWidth = imgRef.current.offsetWidth
    const imageHeight = imgRef.current.offsetHeight
    const xPercentage = (x / imageWidth) * 100
    const yPercentage = (y / imageHeight) * 100

    const foundDifference = state.differences.find(difference => {
      const distance = Math.hypot(
        xPercentage - difference.left,
        yPercentage - difference.top,
      )
      return distance < tolerance && !difference.userFound
    })

    if (foundDifference) {
      differenceSelected(foundDifference.id)
      findDifference(foundDifference.id)
    } else {
      differenceSelected(null)
      createNewSpot(xPercentage, yPercentage, false)
    }
  }
  return (
    <div
      style={{
        position: 'relative',
        dispay: 'flex',
        width: '100%',
        borderRadius: '4px',
        overflow: 'hidden',
        backgroundColor: start ? 'transparent' : 'black',
      }}
    >
      <img
        alt={image.altAttribute || ''}
        ref={imgRef}
        src={`${legacyImageURL(image)}`}
        style={{
          width: '100%',
          height: '100%',
          overflow: 'hidden',
          borderRadius: '4px',
          opacity: start ? 1 : 0.3,
          filter: start ? 'unset' : 'blur(10px)',
          '-webkit-filter': start ? 'unset' : 'blur(10px)',
        }}
      ></img>
      <SpotDiffOverlay differences={state.differences} spots={spots} />
      <InteractionLayer onUserClick={handleUserClick} />
    </div>
  )
}

export default ImageContainer
